import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_INVENTORY_FILTER_DATA_MODEL,
  REQUEST_INVENTORY_LIST_MODEL
} from '@/constants/azure-reserved/azureInventoryConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/util/apiUtils';
import store from '@/store';
import {
  REQUEST_RI_FILTER_DATA_MODEL,
  REQUEST_RI_LIST_MODEL
} from "../../../constants/azure-reserved/azureRianalysisConstants";

export function fetchFilterData(payload) {
  let fetchFilterDataPayload = {
    ...REQUEST_RI_FILTER_DATA_MODEL
  };

  fetchFilterDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_RI.FILTER_DATA, fetchFilterDataPayload)
      .then((response) => {
        // console.log('#####Azure fetchFilterData res', response);
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchRiList(payload) {
  let fetchUsageListPayload = {
    ...REQUEST_RI_LIST_MODEL
  };

  fetchUsageListPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_RI.RI_LIST, fetchUsageListPayload)
      .then((response) => {
        // console.log('#####Azure fetchRiList res', response);
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}




// WEBPACK FOOTER //
// ./src/api/azure-reserved/azure-ri/index.js